'use strict';

import type { AgencyReportUpload } from '../../Entities/Agency/AgencyReportUpload';
import { EntityCollection } from '../EntityCollection';

export class AgencyReportUploadCollection extends EntityCollection<AgencyReportUpload> {}
